import { create } from "zustand";

const qcAtkingPlayersStore = create((set, get) => ({
  atkingPlayers: {},
  setAtkingPlayer: (playerId, playerName, result) => {
    set((state) => ({
      atkingPlayers: {
        ...state.atkingPlayers,
        [playerId]: {
          ...state.atkingPlayers[playerId],
          name: playerName,
          result: result
        },
      },
    }));
  }
}));

export default qcAtkingPlayersStore;
